import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { initKeycloak } from './lib/keycloak';
import { initSentry } from './sentry';
import { SentryErrorBoundary } from './components/ErrorBoundary';
import App from './App';
import './index.css';

initSentry();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

initKeycloak().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <SentryErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </SentryErrorBoundary>
    </StrictMode>,
  );
});
